import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { resetDefaultTdwData as resetDefault, tdw as tdwReport } from '@tencent/tencent-doc-report';
import { getCommonExtData } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/common-ext-data';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { getQuery } from 'sutils';

export interface ITdwOptions {
    opername?: any;
    module?: any;
    action?: any;
    eventcode?: any;
    [key: string]: any;
}

/**
 * tdw上报
 */
export class TdwReport {
    public static editType = 'slide';
    private static isResetTdwData = false;
    private static appEntryType = AppEntryType.PC_EDIT;

    public static init(options: { appEntryType: AppEntryType }) {
        TdwReport.appEntryType = options.appEntryType;
    }

    public static report(options: any = {}, immediate: boolean) {
        // 部分属性需要修正或者改名
        const { entry: source2, from: source3, title: obj2 } = options;
        // eslint-disable-next-line no-param-reassign
        delete options.entry;
        // eslint-disable-next-line no-param-reassign
        delete options.from;
        // eslint-disable-next-line no-param-reassign
        delete options.title;

        const ver8 = {
            dev_route_id: ENV.ENV_ID,
            renderMode: 'canvas',
            isReleaseBuild: ENV.IS_RELEASE,
            // eslint-disable-next-line no-underscore-dangle
            projectBuildVersion: global.__globalReleaseVersion,
            // eslint-disable-next-line no-underscore-dangle
            dwsReleaseVersion: global.__DWS_INFO__?.releaseVersion,
            // 版本
            version: process.env.RELEASE_VERSION,
            // 数据版本
            dataVersion: '3.0.0',
            editTyp: TdwReport.editType,
            ...getCommonExtData({ appEntryType: TdwReport.appEntryType }),
        };
        const params = {
            table: 'dc03111',
            report_type: 101,
            source2,
            source3,
            obj2,
            ver8: JSON.stringify(ver8),
            ...options,
        };
        if (global.clientVars && !TdwReport.isResetTdwData) {
            resetDefaultTdwData();
            TdwReport.isResetTdwData = true;
        }
        tdwReport(params, { showLog: !ENV.IS_RELEASE && getQuery('showTdw'), immediate });
    }
}

/**
 * 重置tdw数据
 */
export function resetDefaultTdwData(): void {
    if (global.isInWorker) return;
    resetDefault();
}

/**
 * 默认上报方式，数据批量上报.
 */
export function tdw(options: ITdwOptions = {}): void {
    if (global.isInWorker) return;
    TdwReport.report(options, false);
}

/**
 * 实时上报
 */
export function tdwImmediate(options: any = {}): void {
    if (global.isInWorker) return;
    TdwReport.report(options, true);
}
